<template>
  <div class="container-fluid px-0" style="height: 620px" ref="vehicleTab">
    <div class="d-flex gap-5 justify-content-between">
      <div class="d-flex gap-5">
        <div
          class="base-button base-button--action"
          @click="$modal.show('addMilage', { type: 7 })"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.3562 4H3.3315C4.41243 2.46296 6.04346 1.6 7.94526 1.6C11.4557 1.6 14.3015 4.46538 14.3015 8H15.8905C15.8905 3.58172 12.3333 0 7.94526 0C5.71722 0 3.75422 0.946009 2.38358 2.61628V0H0.794526V5.6H6.3562V4ZM9.53431 12H12.559C11.4781 13.537 9.84705 14.4 7.94526 14.4C4.43482 14.4 1.58905 11.5346 1.58905 7.99996H0C0 12.4182 3.55721 16 7.94526 16C10.1733 16 12.1363 15.0539 13.5069 13.3837V16H15.096V10.4H9.53431V12Z"
              fill="#1D1E2C"
            />
          </svg>
          <span class="fsc-12 fw-medium lh-sm py-5"> Пробег</span>
        </div>
        <div
          class="base-button base-button--action"
          @click="$modal.show('addMilage', { type: 8 })"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.3562 4H3.3315C4.41243 2.46296 6.04346 1.6 7.94526 1.6C11.4557 1.6 14.3015 4.46538 14.3015 8H15.8905C15.8905 3.58172 12.3333 0 7.94526 0C5.71722 0 3.75422 0.946009 2.38358 2.61628V0H0.794526V5.6H6.3562V4ZM9.53431 12H12.559C11.4781 13.537 9.84705 14.4 7.94526 14.4C4.43482 14.4 1.58905 11.5346 1.58905 7.99996H0C0 12.4182 3.55721 16 7.94526 16C10.1733 16 12.1363 15.0539 13.5069 13.3837V16H15.096V10.4H9.53431V12Z"
              fill="#1D1E2C"
            />
          </svg>

          <span class="fsc-12 fw-medium lh-sm py-5"> МЧ</span>
        </div>
        <!-- <div class="base-button base-button--action"  @click="$modal.show('oilDvsVehicleModalSingle')">
        <span class="fsc-12 fw-medium lh-sm py-5">
          {{ dataLang['vehicle_modal_service_btn_oil_dvs'] }}</span>
      </div>
      <div class="base-button base-button--action"  @click="$modal.show('kppDvsVehicleModalSingle')">
        <span class="fsc-12 fw-medium lh-sm py-5">
          {{ dataLang['vehicle_modal_service_btn_oil_kpp'] }}</span>
      </div> -->
        <div
          class="base-button base-button--action"
          @click="$modal.show('otherVehicleModalSingle', { type: 9 })"
        >
          <span class="fsc-12 fw-medium lh-sm py-5">
            Интервальное событие
          </span>
        </div>
        <div
          class="base-button base-button--action"
          @click="$modal.show('otherVehicleModalSingle', { type: 3 })"
        >
          <span class="fsc-12 fw-medium lh-sm py-5"> Разовое событие </span>
        </div>

        <div
          class="base-button base-button--action"
          @click="$modal.show('refuelingVehicleModalSingle')"
        >
          <span class="fsc-12 fw-medium lh-sm py-5">
            {{ dataLang["vehicle_modal_service_btn_petrol"] }}</span
          >
        </div>
        <div
          class="base-button base-button--action"
          @click="$modal.show('washingVehicleModalSingle')"
        >
          <span class="fsc-12 fw-medium lh-sm py-5">
            {{ dataLang["vehicle_modal_service_btn_washing"] }}</span
          >
        </div>
        <div class="base-button base-button--action" @click="acceptDelete">
          <span class="fsc-12 fw-medium lh-sm py-5">
            {{ dataLang["vehicle_modal_service_btn_delete"] }}</span
          >
        </div>
        <div class="base-button base-button--action" @click="loadExel">
          <img
            :src="require(`@/assets/icons/to-exel.svg`)"
            width="13.5"
            height="13.5"
          />
          <span class="fsc-12 fw-medium lh-sm py-5">в Excel</span>
        </div>
      </div>

      <div class="d-flex gap-5">
        <div
          class="d-flex rounded-5 justify-content-center fsc-12 fw-medium align-items-center text-center text-white cursor-pointer h-100 ws-nowrap"
          style="padding: 5.5px 7.5px; background-color: #023f8f"
          @click="
            $modal.show('orderSendModal', {
              productId: 3,
              productName: 'Автозапчасти',
              objectId: currentOpenedId,
            })
          "
        >
          Заказать ЗЧ
        </div>
        <div
          class="d-flex rounded-5 justify-content-center fsc-12 fw-medium align-items-center text-center text-white cursor-pointer h-100 ws-nowrap"
          style="padding: 5.5px 7.5px; background-color: #023f8f"
          @click="
            $modal.show('orderSendModal', {
              productId: 1,
              productName: 'Слесарный ремонт',
              objectId: currentOpenedId,
            })
          "
        >
          Слесарный ремонт
        </div>
        <div
          class="d-flex rounded-5 justify-content-center fsc-12 fw-medium align-items-center text-center text-white cursor-pointer h-100 ws-nowrap"
          style="padding: 5.5px 7.5px; background-color: #023f8f"
          @click="
            $modal.show('orderSendModal', {
              productId: 2,
              productName: 'Кузовной ремонт',
              objectId: currentOpenedId,
            })
          "
        >
          Кузовной ремонт
        </div>
      </div>
    </div>
    <div class="d-flex wp-100 align-items-center justify-content-between mt-10">
      <div class="d-flex gap-10 fw-medium" style="color: #1d1e2c">
        <div
          v-for="item in listPlanWarnings"
          class="d-flex ws-nowrap py-5 px-10 fsc-12 justify-content-between"
          style="gap: 22px; min-width: 168px"
          :class="item.class"
        >
          <div>{{ item.name }}</div>
          <div>{{ item.value }}</div>
        </div>
      </div>
      <div
        class="text-decoration-underline fsc-12 cursor-pointer"
        @click="$modal.show('planEventsModal', { id: currentOpenedId })"
      >
        Запланировано
      </div>
    </div>
    <div class="d-flex justify-content-between mt-15 mb-5">
      <div class="d-flex gap-15 align-items-center">
        <div
          class="btn btn-sm btn-thrity text-white fsc-14"
          @click="loadData(1)"
        >
          {{ dataLang["register_btn_filter_on"] }}
        </div>
        <div
          class="text-decoration-underline fsc-14 text-dark"
          style="cursor: pointer"
          @click="resetFilter"
        >
          {{ dataLang["register_btn_filter_off"] }}
        </div>
      </div>
      <BasePagination
        :page-count="computedAllPage"
        :pagination-params="activePagePagination"
        :showLimitInput="false"
        @updateLimitValue="updateLimitValue"
        :page-range="16"
        :margin-pages="2"
        :break-view-class="''"
        :click-handler="loadData"
        :prev-text="''"
        :next-text="''"
        :container-class="'custom-pagination'"
        :page-class="'custom-pagination__item'"
        :pageLinkClass="'custom-pagination__item-link'"
        v-if="!localLoading"
      >
      </BasePagination>
    </div>
    <ve-table
      class="rest-style-table"
      style="width: 100%; max-height: 491px; overflow-y: auto"
      :columns="columns"
      :table-data="dataTable"
      :border-x="true"
      :border-y="true"
      :sort-option="sortOption"
      ref="serviceTable"
      row-key-field-name="vehicle_services__id"
      :checkbox-option="{
        hideSelectAll: true,
        selectedRowChange: selectedRowChange,
      }"
      v-if="!localLoading"
      :clickHighlight="false"
      :rowStyleOption="{
        hoverHighlight: true,
      }"
      :cellSelectionOption="{ enable: false }"
    />
    <MilageVehicleModalSingle
      size="md"
      :optionalParams="{ id: currentOpenedId }"
      :minHeight="320"
      :contentLoaded="loadData"
      @click="$modal.show('addMilage')"
    />
    <OilDvsVehicleModalSingle
      size="md"
      :optionalParams="{ id: currentOpenedId }"
      :minHeight="320"
      :contentLoaded="loadData"
      nameForAction="oilDvsVehicleModalSingle"
    />
    <KppDvsVehicleModalSingle
      size="md"
      :optionalParams="{ id: currentOpenedId }"
      :minHeight="320"
      :contentLoaded="loadData"
      nameForAction="kppDvsVehicleModalSingle"
    />
    <OtherVehicleModalSingle
      size="md"
      :optionalParams="{ id: currentOpenedId }"
      :minHeight="320"
      :contentLoaded="loadData"
      nameForAction="otherVehicleModalSingle"
    />
    <TolingVehicleModalSingle
      size="md"
      :optionalParams="{ id: currentOpenedId }"
      :minHeight="320"
      :contentLoaded="loadData"
      nameForAction="tolingVehicleModalSingle"
    />
    <RefuelingVehicleModalSingle
      size="md"
      :optionalParams="{ id: currentOpenedId }"
      :minHeight="320"
      :contentLoaded="loadData"
      nameForAction="refuelingVehicleModalSingle"
    />
    <WashingVehicleModalSingle
      size="md"
      :optionalParams="{ id: currentOpenedId }"
      :minHeight="320"
      :contentLoaded="loadData"
      nameForAction="washingVehicleModalSingle"
    />
    <PlanEventsModal />
    <Teleport to="body">
      <ZapchastiVehicleModalSingle
        size="md"
        :optionalParams="{ id: currentOpenedId }"
        :minHeight="320"
        :contentLoaded="loadData"
        nameForAction="zapchastiVehicleModalSingle"
      />
      <!-- <SimpleModal
        size="md"
        nameForAction="acceptDeletes"
        :modal-title="dataLang['vehicle_modal_service_modals_title_8']"
      >
        <template v-slot:content>
          <div
            class="tw-text-center tw-text-[23px] tw-mb-[15px] tw-text-forTitle"
          >
            {{ dataLang["vehicle_modal_service_modals_warning4"] }}
          </div>
          <div class="tw-h-[10px]"></div>
          <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
            <button
              @click="closeDeleteModal"
              class="tw-app-btn-muted tw-app-btn-muted-lg"
            >
              {{ dataLang["vehile_modal_btn_reset"] }}
            </button>
            <button
              @click="deleteRow"
              class="tw-app-btn-primary tw-app-btn-primary-lg"
            >
              {{ dataLang["vehile_modal_btn_delete_ok"] }}
            </button>
          </div>
        </template>
      </SimpleModal> -->
      <!-- новая модалка для подтверждения удаления, старая - выше, она не работалоа как надо при переключении табов -->
      <BaseModal
        name="ServicesTabAcceptDeletes"
        width="420"
        height="auto"
        :clickToClose="false"
        :shiftY="0.5"
        :adaptive="true"
        classes="!tw-bg-transparent !tw-shadow-none"
      >
        <div
          class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
        >
          <button
            type="button"
            class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
            @click="$modal.hide('ServicesTabAcceptDeletes')"
          ></button>

          <div class="tw-text-center">
            <div class="tw-text-[23px] tw-mb-[15px]">
              <!-- {{ dataLang["vehicle_modal_service_modals_title_8"] }} -->
              {{ dataLang["vehicle_modal_service_modals_warning4"] }}
            </div>

            <div class="tw-h-[10px]"></div>

            <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
              <button
                @click="$modal.hide('ServicesTabAcceptDeletes')"
                class="tw-app-btn-muted tw-app-btn-muted-lg"
              >
                {{ dataLang["vehile_modal_btn_reset"] }}
              </button>
              <button
                @click="deleteRow"
                class="tw-app-btn-primary tw-app-btn-primary-lg"
              >
                {{ dataLang["vehile_modal_btn_delete_ok"] }}
              </button>
            </div>
          </div>
        </div>
      </BaseModal>
      <!-- новая модалка для подтверждения удаления -->
    </Teleport>
    <QuestionModal title="Как искать по дате"/>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { VeTable } from "vue-easytable";
import ObjectsService from "@/api/ObjectsService";
import EventBus from "@/event-bus.js";
import MilageVehicleModalSingle from "@/components/vehicles-page-single-modal-inner/MilageVehicleModalSingle.vue";
import OilDvsVehicleModalSingle from "@/components/vehicles-page-single-modal-inner/OilDvsVehicleModalSingle.vue";
import KppDvsVehicleModalSingle from "@/components/vehicles-page-single-modal-inner/KppDvsVehicleModalSingle.vue";
import OtherVehicleModalSingle from "@/components/vehicles-page-single-modal-inner/OtherVehicleModalSingle.vue";
import RefuelingVehicleModalSingle from "@/components/vehicles-page-single-modal-inner/RefuelingVehicleModalSingle.vue";
import TolingVehicleModalSingle from "@/components/vehicles-page-single-modal-inner/TolingVehicleModalSingle.vue";
import WashingVehicleModalSingle from "@/components/vehicles-page-single-modal-inner/WashingVehicleModalSingle.vue";
import ZapchastiVehicleModalSingle from "@/components/vehicles-page-single-modal-inner/ZapchastiVehicleModalSingle.vue";
import PlanEventsModal from "@/components/vehicles-page-single-modal-inner/PlanEventsModal.vue";
import QuestionModal from "@/views/contracts-modal/QuestionModal.vue";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import SimpleModal from "@/components/vehicles-page-single-modal-inner/SimpleModal.vue";
import SelectsService from "@/api/SelectsService";
import GeneralService from "@/api/GeneralService";

export default {
  components: {
    VeTable,
    MilageVehicleModalSingle,
    OilDvsVehicleModalSingle,
    KppDvsVehicleModalSingle,
    OtherVehicleModalSingle,
    RefuelingVehicleModalSingle,
    WashingVehicleModalSingle,
    TolingVehicleModalSingle,
    ZapchastiVehicleModalSingle,
    PlanEventsModal,
    SimpleModal,
    QuestionModal,
  },

  props: {
    modeOpenModal: {
      type: String,
      default: "create",
    },

    currentOpenedId: {
      type: Number,
    },
  },
  data() {
    return {
      filterDateMask: "",
      selectsData: {
        types: [],
      },
      selectsFilter: {
        type: [],
      },
      localLoading: true,
      dataTable: [],
      activeSelectRowsMultiple: [],
      filter: [],
      computedAllPage: 1,
      activePagePagination: {},
      sortOption: {
        sortChange: (params) => {
          this.sortChange(params);
        },
      },
      rowStyleOption: {
        stripe: true,
      },
      cellSelectionOption: {
        enable: false,
      },
      limitPaginationValue: 16,
      listPlan: [],
      listPlanWarnings: [],
    };
  },
  methods: {
    updateLimitValue(data) {
      this.limitPaginationValue = data;
      this.loadData();
      // this.getTransportVehiclesAll({
      //   page: 1,
      //   limit: this.limitPaginationValue,
      // })
    },
    sendData(callback, nameTab, oldTab, newTab, flagIsClose) {
      EventBus.$emit("contentLoaded");
      EventBus.$emit("updateContentData");
      callback(true, nameTab, oldTab, newTab, flagIsClose);
    },
    removeDuplicates(arr) {
      const seen = new Set();

      return arr.filter((item) => {
        const key = `${item.field}_${item.value}`;
        if (seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      });
    },
    async loadExel() {
      let whereContent = [
        ...this.filter,
        ...(this.filterDateMask
          ? [
              {
                field: "vehicle_services__created_at",
                value: this.filterDateMask,
                mod: "datetime.mask",
              },
            ]
          : []),
      ];
      let dataFrom = await ObjectsService.toExcel(this.currentOpenedId, {
        // ...(this.filter.length ?? { where: JSON.stringify(this.filter) }) // old fashioned
        ...((this.filter.length || !!this.filterDateMask) && {
          where: JSON.stringify(this.removeDuplicates(whereContent)),
        }),
      });

      const filename = new Date().toISOString();
      const url = window.URL.createObjectURL(dataFrom.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${filename}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    acceptDelete() {
      if (this.activeSelectRowsMultiple.length) {
        this.$modal.show('ServicesTabAcceptDeletes')
        // EventBus.$emit("openModal", {
        //   data: null,
        //   nameForAction: "acceptDeletes",
        //   mode: "create",
        // });
      } else {
        this.$toast.error("Выберите хотя-бы одно поле", { duration: 5000 });
      }
    },
    // closeDeleteModal() {
    //   EventBus.$emit("closeModal", {
    //     data: null,
    //     nameForAction: "acceptDeletes",
    //     mode: "create",
    //   });
    // },

    deleteRow() {
      this.$emit("loadingModal", true);
      // this.closeDeleteModal();
      this.$modal.hide('ServicesTabAcceptDeletes')
      ObjectsService.delete(
        "services",
        this.currentOpenedId,
        this.activeSelectRowsMultiple
      )
        .then((data) => {
          this.loadData();
          this.activeSelectRowsMultiple = [];

          EventBus.$emit("updateContentData");
          this.getHealth(this.currentOpenedId);
          this.getTitle(this.currentOpenedId);
        })
        .catch((err) => {
          this.$emit("loadingModal", false);

          this.activeSelectRowsMultiple = [];
          this.$toast.error(err.response.data.message, { duration: 5000 });
        });
    },
    openModalSingle(nameModal) {
      EventBus.$emit("openModal", {
        data: null,
        nameForAction: nameModal,
        mode: "create",
      });
    },
    loadData(newNumPage) {
      this.$emit("loadingModal", true);
      this.urlToQuaries.params.page = newNumPage;
      Promise.all([
        ObjectsService.getAll(this.urlToQuaries).then((data) => {
          this.$emit("loadingModal", false);
          this.activePagePagination = data.data.data;
          this.computedAllPage = data.data.data.total / data.data.data.limit;
          this.dataTable = data.data.data.rows;
          this.activeSelectRowsMultiple = [];
        }),
        ObjectsService.getAll({ url: "/services/types" }).then((data) => {
          this.selectsData.types = data.data.data.rows;
          // this.$emit('loadingModal', false)
          // this.activePagePagination = data.data.data
          // this.computedAllPage = data.data.data.total / data.data.data.limit
          // this.dataTable = data.data.data.rows
          // this.activeSelectRowsMultiple = []
        }),
        GeneralService.get(
          `/object_interval_events_plan/${this.currentOpenedId}`
        )
          .then((data) => {
            this.listPlanWarnings = [];
            this.listPlan = data.data.data.rows || [];
            this.listPlan.forEach((el) => {
              if (el.settings && Object.keys(el.settings).length) {
                Object.keys(el.settings).forEach((element) => {
                  const cls = el.settings[element];
                  // include both red and yellow status items, with shared total limit below
                  if (
                    [
                      "cell-status-red",
                      "cell-status-yellow",
                      "cell-status-orange",
                    ].includes(cls)
                  ) {
                    let val = el[element];
                    // if value is a date, format to DD.MM.YYYY
                    if (
                      val &&
                      typeof val === "string" &&
                      dayjs(val).isValid()
                    ) {
                      val = dayjs(val).format("DD.MM.YYYY");
                    }
                    this.listPlanWarnings.push({
                      name: el.vehicle_interval_event_plans__name || "",
                      value: val,
                      class: cls,
                    });
                  }
                });
              }
            });

            this.listPlanWarnings = this.listPlanWarnings.slice(0, 5);
          })
          .catch((e) => {}),
      ]).then(() => {
        this.localLoading = false;
      });
    },
    resetFilter() {
      // this.selectsData
      this.filter = [];
      this.filterDateMask = "";
      this.loadData();
      if (this.$refs.vehicleServicesCreatedMaskFilter) {
        this.$refs.vehicleServicesCreatedMaskFilter.value = "";
      }

      this.selectsFilter = {
        type: [],
      };
      this.$refs.serviceTable.$el
        .querySelectorAll("input.base-input--new")
        .forEach((elem, index) => {
          elem.value = "";
        });
    },
    sortChange(params) {
      this.dataTable.sort((a, b) => {
        if (params.vehicle_services__created_at) {
          if (params.vehicle_services__created_at === "asc") {
            return (
              a.vehicle_services__created_at - b.vehicle_services__created_at
            );
          } else if (params.vehicle_services__created_at === "desc") {
            return (
              b.vehicle_services__created_at - a.vehicle_services__created_at
            );
          } else {
            return 0;
          }
        }
        if (params.vehicle_services__odometr) {
          if (params.vehicle_services__odometr === "asc") {
            return a.vehicle_services__odometr - b.vehicle_services__odometr;
          } else if (params.vehicle_services__odometr === "desc") {
            return b.vehicle_services__odometr - a.vehicle_services__odometr;
          } else {
            return 0;
          }
        }
        if (params.vehicle_services__text) {
          if (params.vehicle_services__text === "asc") {
            return a.vehicle_services__text - b.vehicle_services__text;
          } else if (params.vehicle_services__text === "desc") {
            return b.vehicle_services__text - a.vehicle_services__text;
          } else {
            return 0;
          }
        }
        if (params.vehicle_services__price) {
          if (params.vehicle_services__price === "asc") {
            return a.vehicle_services__price - b.vehicle_services__price;
          } else if (params.vehicle_services__price === "desc") {
            return b.vehicle_services__price - a.vehicle_services__price;
          } else {
            return 0;
          }
        }
        if (params.employees__name) {
          if (params.employees__name === "asc") {
            return a.employees__name - b.employees__name;
          } else if (params.employees__name === "desc") {
            return b.employees__name - a.employees__name;
          } else {
            return 0;
          }
        }
      });
    },
    fillFilter(data) {
      let newValueFilter =
        data.type == "like" ? `;percent;${data.value};percent;` : data.value;
      if (!this.filter.find((x) => x.field == data.name)) {
        this.filter.push({
          field: data.name,
          value: newValueFilter,
          ...(data.type == "like" && { operator: "like" }),
        });
      } else {
        this.filter[this.filter.findIndex((x) => x.field == data.name)].value =
          newValueFilter;
      }
    },
    prepareLabelsForDefaultSelects(data, keyDataFromFetch, toTranslate) {
      for (const key in data) {
        data[key].forEach((element) => {
          element["label"] = element[Object.keys(element).pop()];
          element["key"] = key;
          element["value"] = Object.keys(element)[0];
          element["selectName"] = keyDataFromFetch;
        });
      }
      return data;
    },
    sanitizeVehicleServicesCreatedMask(raw) {
      // allow only digits and dots, max 2 dots, max length 10; auto-insert dots when none provided
      const cleaned = (raw || "").replace(/[^\d.]/g, "");

      // If user already typed dots, just clamp count/length
      let dots = 0;
      let out = "";
      for (const ch of cleaned) {
        if (ch === ".") {
          if (dots >= 2) continue;
          dots += 1;
          out += ch;
        } else {
          out += ch;
        }
        if (out.length >= 10) break;
      }

      // Auto-insert dots only when there are zero dots AND at least 3 digits typed (avoid early insertion after 1-2 digits)
      if (dots === 0) {
        const digits = out.replace(/\./g, "");
        if (digits.length >= 3) {
          const limited = digits.slice(0, 8);
          const parts = [];
          parts.push(limited.slice(0, 2)); // DD
          if (limited.length > 2) parts.push(limited.slice(2, 4)); // MM
          if (limited.length > 4) parts.push(limited.slice(4, 8)); // YYYY (up to 4 digits)
          return parts.filter(Boolean).join(".").slice(0, 10);
        }
      }

      return out;
    },
    setVehicleServicesCreatedMaskFilter(eventOrValue) {
      const raw =
        eventOrValue && eventOrValue.target
          ? eventOrValue.target.value
          : eventOrValue;
      const masked = this.sanitizeVehicleServicesCreatedMask(raw || "");

      // Reflect masked value back into the input for immediate feedback
      if (eventOrValue && eventOrValue.target) {
        eventOrValue.target.value = masked;
      }

      this.filterDateMask = masked;

      const idx = this.filter.findIndex(
        (x) =>
          x.field === "vehicle_services__created_at" &&
          x.mod === "datetime.mask"
      );

      if (masked) {
        const entry = {
          field: "vehicle_services__created_at",
          value: masked,
          mod: "datetime.mask",
        };
        if (idx >= 0) {
          this.filter.splice(idx, 1, entry);
        } else {
          this.filter.push(entry);
        }
      } else if (idx >= 0) {
        this.filter.splice(idx, 1);
      }
    },
    ...mapActions("transportVehiclesModule", ["getHealth", "getTitle"]),
  },
  mounted() {
    EventBus.$on("contentLoaded", () => {
      this.loadData();
    });
    dayjs.extend(utc);
  },
  created() {
    this.$emit("loadingModal", true);
    this.getHealth(this.currentOpenedId);
    this.getTitle(this.currentOpenedId);
    this.loadData(1);
  },
  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
    urlToQuaries() {
      let whereContent = [
        ...this.filter,
        ...(this.filterDateMask
          ? [
              {
                field: "vehicle_services__created_at",
                value: this.filterDateMask,
                mod: "datetime.mask",
              },
            ]
          : []),
      ];
      return {
        url: `/${this.currentOpenedId}/services`,
        params: {
          limit: this.limitPaginationValue,
          page: 1,
          // ...(this.filter.length && { where: JSON.stringify(this.filter) })
          ...((this.filter.length || !!this.filterDateMask) && {
            where: JSON.stringify(this.removeDuplicates(whereContent)),
          }),
        },
      };
    },
    columns() {
      return [
        {
          field: "",
          key: "a",

          type: "checkbox",
          title: "",
          width: "2%",
          align: "center",
        },
        {
          field: "vehicle_services__created_at",
          key: "1",
          title: this.dataLang["vehicle_modal_service_table_header_date"],
          align: "center",
          width: "10%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center d-flex gap-5 align-items-center"}>
                  {column.title}{" "}
                  <img
                    onClick={() =>
                      this.$modal.show("questionModal", {
                        text: 'Поиск по дате/ месяцу/ году.\n Напомним, что дата выглядит так “01.01.1980” \n (две цифры-точка-две цифры-точка-четыре цифры) \n Поэтому, при поиске части даты, не забудьте про точки! \n Чтобы найти точную дату 01.01.1980, введите в поле “01.01.1980” \n Чтобы найти все даты с “январем 1980 года”, введите в поле ".01.1980” \n Чтобы найти все даты с “1 января”, введите в поле “01.01.” \n Чтобы найти все даты с “январем”, введите в поле “.01.” \n Чтобы найти все даты с “1980 годом”, введите в поле “..1980”',
                      })
                    }
                    src={require(`@/assets/icons/question.svg`)}
                    class="cursor-pointer"
                    width="12"
                    height="12"
                  />
                </div>
                <input
                  ref="vehicleServicesCreatedMaskFilter"
                  type="text"
                  class="base-input--new fsc-11"
                  placeholder="__.__.____"
                  value={this.filterDateMask}
                  onInput={(e) => this.setVehicleServicesCreatedMaskFilter(e)}
                  style={{ width: "100%" }}
                  inputmode="numeric"
                />
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.vehicle_services__created_at
                  ? dayjs(row.vehicle_services__created_at)
                      .utc(true)
                      .utcOffset(Number(this.userSetting.company__utc))
                      .format(
                        `${this.userSetting.company__tempalte_date} HH:mm`
                      )
                  : ""}
              </span>
            );
          },
        },

        {
          field: "vehicle_services__odometr",
          key: "2",
          title: this.dataLang["vehicle_modal_service_table_header_odometr"],
          align: "center",
          width: "8%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "vehicle_services__motohour",
          key: "2231",
          title: "Моточасов",
          align: "center",
          width: "8%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
        {
          field: "vehicle_services__name",
          key: "3",
          title: this.dataLang["vehicle_modal_service_table_header_type"],
          align: "center",
          width: 70,
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },

          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <span>{column.title}</span>
                <BaseInputNew
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"vehicle_services__name"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "vehicle_services__text",
          key: "4",
          title: "Комментарий",
          align: "center",
          width: 70,
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>
                <BaseInputNew
                  placeholder=""
                  style={"width: 100%"}
                  disabled={false}
                  onInput={this.fillFilter}
                  additionalParams={{ type: "like" }}
                  inputName={"vehicle_services__text"}
                  value={""}
                  nameSign={""}
                />
              </div>
            );
          },
        },
        {
          field: "vehicle_services__price",
          key: "5",
          title: "Стоимость",
          align: "center",
          width: "8%",
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {String(row.vehicle_services__price).replace(".", ",")}
              </span>
            );
          },
        },
        {
          field: "employees__name",
          key: "6",
          title: "Исполнитель",
          align: "center",
          width: 70,
          sortBy: "",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderHeaderCell: ({ column }, h) => {
            return (
              <div>
                <div class={"text-center"}>{column.title}</div>

                <div style={"height: 19.5px"}></div>
              </div>
            );
          },
        },
      ];
    },
  },
};
</script>
